import React from 'react';
import { DateCellWrapperProps } from 'react-big-calendar';
import { useNavigate } from 'react-router-dom';
import { Event } from '../SFCCalendar';

interface CustomDayCellProp {
  date?: Date;
  eventCount: number;
  currentDates?: string[];
  linkParams?: string;
}

const CustomDayCell: React.FC<CustomDayCellProp> = ({ date, eventCount, currentDates, linkParams }) => {
  const navigate = useNavigate();
  return (
      <div style={{ marginTop: 30 }}>
        {eventCount > 0 && (
            <div
                className="rbc-event bg-primary py-1"
                style={{ cursor: 'pointer' }}
                onClick={() => {
                  const day = date ? date.toISOString().slice(0, 10) : '';
                  const extra = linkParams ? `&${linkParams}` : '';
                  navigate(`/admin/schedule/classes?starts_on=${day}&ends_on=${day}${extra}`);
                }}
            >
              {eventCount} Classes
            </div>
        )}
      </div>
  );
};


interface CustomDayCellWrapperProps extends DateCellWrapperProps {
  summarized?: boolean;
  events: Event[];
  currentDates?: string[];
  linkParams?: string;
}

export const CustomDayCellWrapper: React.FC<CustomDayCellWrapperProps> = ({
  value,
  children,
  summarized,
  events,
  currentDates,
  linkParams
}) => {
  return (
    <div
      className={children.props.className}
      style={{ zIndex: summarized ? 10 : 1 }}
    >
      {summarized && (
          <CustomDayCell
              date={value}
              eventCount={events.length}
              currentDates={currentDates}
              linkParams={linkParams}
          />
      )}
      {children}
    </div>
  );
};
